module.exports = __webpack_public_path__ + "media/images/favicon/favicon-16x16-d7e8605b196c4bfcebe37ebdafac075f.png";